import React from "react";
import logo from "../../../assets/images/logo.png";

const BillingFooter = ({
  footerData,
  informationData,
  selectedSections,
}: {
  footerData: any;
  informationData: any;
  selectedSections: { [key: string]: boolean };
}) => {
  const footerContainer = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-end",
    marginTop: "20px",
    fontSize: "12px",
    width: "100%",
  };
  const logoStyle = {
    width: "100%",
    objectFit: "contain",
  };

  return (
    <div style={footerContainer}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          marginTop: "40px",
        }}>
        <span
          style={{
            fontSize: "7px",
            color: "gray",
            marginLeft: "46px",
          }}>
          Powered by
        </span>
        <img
          src={logo}
          alt="Footer Logo"
          style={{ ...logoStyle, width: "100px", height: "20px" }}
        />
      </div>
      {selectedSections?.FOOTER && informationData?.footerEnable && (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
          }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "5px",
            }}>
            {footerData?.stampServerImage && (
              <div style={{ width: "60px", height: "60px" }}>
                <img
                  src={`data:image/png;base64,${footerData?.stampServerImage}`}
                  alt="Stamp"
                  style={logoStyle}
                />
              </div>
            )}
            {footerData?.signatureServerImage && (
              <div style={{ width: "100px", height: "40px" }}>
                <img
                  src={`data:image/png;base64,${footerData?.signatureServerImage}`}
                  alt="signature"
                  style={logoStyle}
                />
              </div>
            )}
          </div>
          <div style={{ fontSize: "12px", marginTop: "2px" }}>
            <span>Authorised Signatory</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default BillingFooter;
